import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaAvatar from './VaAvatar.vue'

export default withConfigTransport(VaAvatar)
